import axios from '../internal/axios';
export var getCart = function getCart() {
  return axios.get('cart').then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return result.data;
    } else {
      throw Error(result.message);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;
    return {
      error: message
    };
  });
}; // tslint:disable-next-line:variable-name

export var addCart = function addCart(purchase_unit_id) {
  return axios.post('cart', {
    purchase_unit_id: purchase_unit_id
  }).then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return result.data;
    } else {
      throw Error(result.message);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;
    return {
      error: message
    };
  });
}; // tslint:disable-next-line:variable-name

export var deleteCart = function deleteCart(purchase_unit_id) {
  return axios.request({
    url: "cart/".concat(purchase_unit_id),
    method: 'DELETE'
  }).then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return result.data;
    } else {
      throw Error(result.message);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;
    return {
      error: message
    };
  });
};
export var clearCart = function clearCart() {
  return axios.request({
    url: 'cart',
    method: 'DELETE'
  }).then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return result.data;
    } else {
      throw Error(result.message);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;
    return {
      error: message
    };
  });
};